const url = new URL(document.currentScript.src);
__webpack_public_path__ = `${url.href.split('/js')[0]}/${__webpack_public_path__}`;
